function isGreater(date1: string | Date, date2: string | Date): boolean {
  const d1 = toValidDate(date1);
  const d2 = toValidDate(date2);

  if (!d1 || !d2) return false; // safer fallback

  return d1.getTime() > d2.getTime();
}

function toValidDate(value: string | Date): Date | null {
  if (value instanceof Date) return value;

  // Format "2025-11-17 07:43:18" → "2025-11-17T07:43:18"
  const formatted = value.replace(" ", "T");

  const parsed = new Date(formatted);

  return isNaN(parsed.getTime()) ? null : parsed;
}

export default isGreater